import {Component} from "../interface/component";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../container/identifiers";
import {ModalService} from "../service/modal";
import {LoadingService} from "../service/loading";

@injectable()
export class CoursePublishComponent implements Component {

    private $root:JQuery;
    private $shoudUseBooking:JQuery;
    private $curatorspaceBookings:JQuery;
    private $externalBookings:JQuery;
    @inject(SERVICE_IDENTIFIER.MODAL) public modalService: ModalService;
    @inject(SERVICE_IDENTIFIER.LOADING) public loadingService: LoadingService;

    init(elem:HTMLElement) {
        this.$root = $(elem);
        this.bindUI();
    }

    private bindUI() {
        this.$root.on({ click: this.handlePublishCourse })
    }

    handlePublishCourse = (ev:any) => {
        ev.preventDefault();
        if (this.$root.data('can_publish')) {
            let id = this.$root.data('id') ? this.$root.data('id') : this.$root.closest('tr').data('id');
            this.loadingService.showLoading();
            $
                .ajax({
                    type: 'GET',
                    url: '/members/courses/publish-form?id=' + id
                })
                .done((content) => {
                    this.loadingService.hideLoading();
                    let $modal = this.modalService.showConfirm(
                        'Publish this course?', content, [
                            {
                                label: 'Cancel',
                                class: 'btn-default',
                                events: {
                                    click: () => this.modalService.hideConfirm()
                                }
                            },
                            {
                                label: 'Publish now',
                                class: 'btn-danger',
                                events: {
                                    click: () => (<HTMLFormElement>$modal.find('form').get(0)).submit()
                                }
                            }
                        ]
                    );
                })
            ;
        } else {
            this.modalService.showConfirm(
                'You cannot publish this course', "<p>Before you can publish a course using CuratorSpace you must set up your bank account to be able to accept payments. Click on the button below to do this.", [
                    {
                        label: 'Cancel',
                        class: 'btn-default',
                        events: {
                            click: () => this.modalService.hideConfirm()
                        }
                    },
                    {
                        label: 'Setup my bank account',
                        class: 'btn-danger',
                        events: {
                            click: () => (<any>window).location = '/members/account/setup-payments?redirect=/members/courses&redirect_to=my%20courses',
                        }
                    }
                ]
            );
        }
    };
}